import ConditionalRuleSet from "../conditionalRules/conditionalRuleSet";
import Repo from "../../state/modules/repo";
import IRepo from "../../interfaces/repo";
import {ConditionalFieldDefinition} from "../conditionalRules/conditionalFieldDefinition";
import VisualizationDataPointConditionalRule from "~/models/visualizations/visualizationDataPointConditionalRule";

export default class VisualizationDataPointConditionalRuleSet extends ConditionalRuleSet {
  static repo: IRepo<VisualizationDataPointConditionalRuleSet> = new Repo('conditionalRuleSets', VisualizationDataPointConditionalRuleSet);

  constructor(fieldName: string, definition: ConditionalFieldDefinition) {
    super(fieldName, definition);
  }

  createNew(fieldName: string, conditionalFieldDefinition: ConditionalFieldDefinition): ConditionalRuleSet {
    return new VisualizationDataPointConditionalRuleSet(fieldName, conditionalFieldDefinition);
  }

  createNewRule(): VisualizationDataPointConditionalRule {
    return new VisualizationDataPointConditionalRule();
  }
}